import NotificationManager from '../../components/common/react-notifications/NotificationManager'

export const FILM_LOADING = 'FILM_LOADING'

export const setLoadingFilmAction = (loading) => (dispatch,) => dispatch({
	type: FILM_LOADING,
	loading,
},)

export const filmCreateAction = (action, variables,) => async (dispatch,) => {
	try {
		dispatch(setLoadingFilmAction(true))
		const { data, } = await action({ variables, })
		dispatch(setLoadingFilmAction(false))
		return data.movie.id
	} catch (e) {
		NotificationManager.error(
			e.message || '',
			'Проблема создания',
			3000,
			null,
			null,
		)
		dispatch(setLoadingFilmAction(false))
		return null
	}
}

export const filmUpdateAction = (action, variables,) => async (dispatch,) => {
	try {
		dispatch(setLoadingFilmAction(true))
		const { data, } = await action({ variables, })
		return data.film
	} catch (e) {
		NotificationManager.error(
			e.message || '',
			'Проблема Обновления',
			3000,
			null,
			null,
		)
		dispatch(setLoadingFilmAction(false))
	}
	dispatch(setLoadingFilmAction(false))
}
